module.exports = __webpack_public_path__ + "static/media/prism-gif-2.5fbec02a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/prism-gif-2.gif
// module id = 501
// module chunks = 0